import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visitorsvision',
  templateUrl: './visitorsvision.component.html',
  styleUrls: ['./visitorsvision.component.scss']
})
export class VisitorsvisionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
